/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_BuscarConversacion as BuscarConversacion,
  rec_EstadoError as EstadoError,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_Sn as Sn,
  rec_ZC as ZC,
  rec_api as api,
  rec_ii as ii,
  rec_ra as ra,
} from "../../runtime/index.jsx";
export function AsignacionesPorArea() {
  let e = Go(),
    [t, n] = (0, React.useState)(null),
    [r, i] = (0, React.useState)(``),
    [a, o] = (0, React.useState)(null),
    s = (0, React.useCallback)(async () => {
      i(``);
      try {
        n(
          await api(`/configuracion/areas-por-sector`, {
            sinCache: !0,
          }),
        );
      } catch (e) {
        i(e.message);
      }
    }, []);
  (0, React.useEffect)(() => {
    s();
  }, [s]);
  let c = (0, React.useMemo)(
      () => new Map((t?.unidades ?? []).map((e) => [e.id, e])),
      [t],
    ),
    l = (0, React.useMemo)(
      () =>
        (t?.unidades ?? []).map((e) => ({
          value: e.id,
          label: ZC(e.ruta || e.nombre, e),
        })),
      [t],
    );
  async function u(t, n, r, i) {
    o(t);
    try {
      (await api(n, {
        method: `PUT`,
        body: JSON.stringify(r),
      }),
        e.ok(i),
        await s());
    } catch (t) {
      e.error(t.message);
    } finally {
      o(null);
    }
  }
  return r ? (
    <EstadoError mensaje={r} onReintentar={s} />
  ) : t ? (
    <div
      className={`mx-auto flex w-full max-w-5xl flex-col gap-5`}
      children={[
        t.unidades.length === 0 && (
          <p
            className={`rounded-2xl border border-(--border) bg-(--bg) p-4 text-sm text-(--text)`}
            children={[
              `Todavía no hay grupos en la organización. Cargalos en `,
              <Sn
                to={`/organizacion`}
                className={`font-medium text-(--accent-texto) underline`}
                children={`Organización`}
              />,
              ` y volvé acá.`,
            ]}
          />
        ),
        <section
          className={`flex flex-col gap-2`}
          children={[
            <h2
              className={`text-sm font-medium text-(--text-h) !m-0`}
              children={`Qué grupo hace cada acta`}
            />,
            <p
              className={`text-xs text-(--text)`}
              children={`Sólo quien está a cargo de estos grupos puede empezar el acta.`}
            />,
            <ul
              className={`${Bo} flex flex-col divide-y divide-(--border) !p-0`}
              children={t.actas.map((e) => {
                let t = e.unidadIds,
                  n = l.filter((e) => !t.includes(e.value)),
                  r = `acta-${e.plantillaId}`;
                return (
                  <li
                    key={e.plantillaId}
                    className={`flex flex-col gap-2 p-3 sm:flex-row sm:items-start`}
                    children={[
                      <span
                        className={`text-sm font-medium text-(--text-h) sm:w-56 sm:shrink-0 sm:pt-2`}
                        children={e.nombre}
                      />,
                      <div
                        className={`flex min-w-0 flex-1 flex-col gap-2`}
                        children={[
                          <div
                            className={`flex flex-wrap gap-1.5`}
                            children={[
                              t.length === 0 && (
                                <span
                                  className={`text-xs text-(--warning)`}
                                  children={`Ningún grupo: nadie puede empezarla.`}
                                />
                              ),
                              t.map((n) => (
                                <span
                                  key={n}
                                  className={`inline-flex items-center gap-1 rounded-full border border-(--border) bg-(--panel) py-1 pr-1 pl-3 text-xs text-(--text-h)`}
                                  children={[
                                    c.get(n)?.ruta ??
                                      c.get(n)?.nombre ??
                                      `#${n}`,
                                    <button
                                      type={`button`}
                                      disabled={a === r}
                                      aria-label={`Quitar ${c.get(n)?.nombre ?? n} de ${e.nombre}`}
                                      onClick={() =>
                                        u(
                                          r,
                                          `/configuracion/areas-por-sector/actas/${e.plantillaId}`,
                                          {
                                            unidadIds: t.filter((e) => e !== n),
                                          },
                                          `Grupo quitado`,
                                        )
                                      }
                                      className={`rounded-full p-1.5 text-(--text) hover:bg-(--error-bg) hover:text-(--error)`}
                                      children={(0, JSXRuntime.jsx)(ra, {
                                        className: `h-3 w-3`,
                                      })}
                                    />,
                                  ]}
                                />
                              )),
                            ]}
                          />,
                          n.length > 0 && (
                            <BuscarConversacion
                              value={``}
                              opciones={n}
                              placeholder={`Agregar un grupo…`}
                              onChange={(n) => {
                                n &&
                                  u(
                                    r,
                                    `/configuracion/areas-por-sector/actas/${e.plantillaId}`,
                                    {
                                      unidadIds: [...t, Number(n)],
                                    },
                                    `Grupo agregado`,
                                  );
                              }}
                            />
                          ),
                        ]}
                      />,
                    ]}
                  />
                );
              })}
            />,
          ]}
        />,
        <section
          className={`flex flex-col gap-2`}
          children={[
            <h2
              className={`text-sm font-medium text-(--text-h) !m-0`}
              children={`A qué área va cada incidencia`}
            />,
            <p
              className={`text-xs text-(--text)`}
              children={`Sin área, la incidencia entra igual pero no le llega a nadie.`}
            />,
            <ul
              className={`${Bo} flex flex-col divide-y divide-(--border) !p-0`}
              children={t.incidencias.map((e) => {
                let t = `inc-${e.tipoId}`,
                  n = e.unidadId ? c.get(e.unidadId) : null;
                return (
                  <li
                    key={e.tipoId}
                    className={`flex flex-col gap-2 p-3 sm:flex-row sm:items-center`}
                    children={[
                      <span
                        className={`text-sm font-medium text-(--text-h) sm:w-56 sm:shrink-0`}
                        children={e.nombre}
                      />,
                      <div
                        className={`flex min-w-0 flex-1 items-center gap-2`}
                        children={[
                          <div
                            className={`min-w-0 flex-1`}
                            children={
                              <BuscarConversacion
                                value={e.unidadId ?? ``}
                                opciones={l}
                                placeholder={
                                  n ? n.ruta || n.nombre : `Elegí el área…`
                                }
                                onChange={(n) => {
                                  n &&
                                    u(
                                      t,
                                      `/configuracion/areas-por-sector/incidencias/${e.tipoId}`,
                                      {
                                        unidadId: Number(n),
                                      },
                                      `Área asignada`,
                                    );
                                }}
                              />
                            }
                          />,
                          e.unidadId && (
                            <button
                              type={`button`}
                              disabled={a === t}
                              aria-label={`Dejar ${e.nombre} sin área`}
                              onClick={() =>
                                u(
                                  t,
                                  `/configuracion/areas-por-sector/incidencias/${e.tipoId}`,
                                  {
                                    unidadId: null,
                                  },
                                  `Quedó sin área`,
                                )
                              }
                              className={`rounded-lg p-2 text-(--text) hover:bg-(--error-bg) hover:text-(--error)`}
                              children={(0, JSXRuntime.jsx)(ra, {
                                className: `h-4 w-4`,
                              })}
                            />
                          ),
                          !e.unidadId && (
                            <span
                              className={`shrink-0 text-xs text-(--warning)`}
                              children={`Sin área`}
                            />
                          ),
                        ]}
                      />,
                    ]}
                  />
                );
              })}
            />,
          ]}
        />,
      ]}
    />
  ) : (
    <div
      className={`flex justify-center py-16 text-(--text)`}
      children={(0, JSXRuntime.jsx)(ii, {
        className: `h-6 w-6 animate-spin`,
      })}
    />
  );
}
